<template lang="pug">
.campaigns(@click="onItemCode")
  //- Google Review 英雄区(layout=googleReviewHeroV1):图标(上,大) → 文字 → 图片(下)
  template(v-if="isReviewHero")
    .review_icon_box
      img.review_icon(src="@/assets/icon/google-g.svg" v-if="data.settings.campaign.icon !== 'review'")
      img.review_icon(src="@/assets/icon/review-icon.svg" v-if="data.settings.campaign.icon === 'review'")
    .review_html(v-html="isHtml")
    .campaigns_img(v-if="localizedImage")
      img.image.img_box(:src="localizedImage")
  //- 第三方评价 默认版:图片 → 图标 → 文字
  template(v-else-if="isThirdPartyReview")
    .campaigns_img
      .logo_box
        img.logo(v-if="localizedLogo" :src="localizedLogo")
      img.image.img_box(v-if="localizedImage" :src="localizedImage")
      img.review_icon(src="@/assets/icon/google-g.svg" v-if="data.settings.campaign.icon !== 'review'")
      img.review_icon(src="@/assets/icon/review-icon.svg" v-if="data.settings.campaign.icon === 'review'")
    .review_html(v-html="isHtml")
  //- 普通 campaign
  template(v-else)
    .campaigns_img
      .logo_box
        img.logo(v-if="localizedLogo" :src="localizedLogo")
      img.image.img_box(v-if="localizedImage" :src="localizedImage")
    .campaigns_html(ref="campaigns_html" v-html="isHtml")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField, t } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object,
  },
  computed: {
    // Get localized logo / 获取本地化的 logo
    localizedLogo() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'logo')
    },

    // Get localized image / 获取本地化的 image
    localizedImage() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'image')
    },

    // If there is open:terms after the tag a, add the class name terms to the tag a and add target="_blank" to each tag a
    // 如果 a 标签后有 'open:terms'，则给 a 标签添加类名 'terms'，并且每个 a 标签添加 'target="_blank"'
    isHtml() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      let description = getLocalizedCampaignField(this.data, 'description') || ''
      // If enableTerms is true, Terms & condition will be displayed
      // 若 enableTerms 为 true，则显示 'Terms & condition'
      if (this.data?.settings?.enableTerms) {
        description += `<br><a href="open:terms">${t('terms_and_conditions', 'Terms & conditions')}</a>`
      }
      description = description.replace(
        /"open:terms"/g,
        '"open:terms" class=\'terms\'',
      )
      description = description.replace(/<a /g, ' <a target="_blank" ')
      return description
    },

    isThirdPartyReview() {
      return this.data?.settings?.campaign?.type === 'thirdPartyReview'
    },

    // Google Review 英雄区版式(layout === 'googleReviewHeroV1')
    isReviewHero() {
      return this.isThirdPartyReview && this.data?.settings?.campaign?.layout === 'googleReviewHeroV1'
    }
  },
})

class campaignComponents extends Vue {
  onItemCode(e) {
    // If the event proxy is an event triggered by the terms element of the class name, it follows this logic
    // 事件代理。如果是类名 terms 元素触发的事件，就走这个逻辑
    if (e.target.classList.contains('terms')) {
      e.preventDefault() // Block Default Events   // 阻止默认事件
      this.$emit('open', true) // Activity page, opening events   // 活动页面，打开事件
    }
  }
}

export default campaignComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *

::v-deep .van-overlay
  z-index: 6

.campaigns
  display: flex
  flex-direction: column
  padding: 0 17px 40px 17px

  .campaigns_button
    margin-top: 15px

  .campaigns_img
    width: 100%
    padding-top: 20px
    text-align: center

    .logo_box
      display: flex
      justify-content: center

      .logo
        width: 50%
        margin-bottom: 20px

    .image
      width: 100%

    .review_icon
      width: 78PX
      height: 78PX
      margin-top: -20PX
      margin-bottom: 20PX

  .review_icon_box
    padding-top: 20px
    text-align: center

    .review_icon
      width: 96PX
      height: 96PX

  .campaigns_button
    margin-top: 18px
    font-size: 13px
    font-weight: 400
    line-height: 16px
    opacity: 1

    .connection
      text-decoration: underline
      color: var(--menu-primary-background-colour) !important

  .review_html
    font-size: 16px
    text-align: center
    ::v-deep
      *
        white-space: pre-wrap !important

      .terms
        text-decoration: underline
        color: var(--menu-primary-text-colour) !important
  .campaigns_html
    font-size: 16px

    ::v-deep
      *
        white-space: pre-wrap !important

      .terms
        text-decoration: underline
        color: var(--menu-primary-text-colour) !important
</style>
